import { Link } from "react-router-dom";
import Reveal from "../Reveal";
import SectionHeading from "../SectionHeading";
import Button from "../Button";
import resume from "../../_data/resume.json";
import { useCopy } from "../../i18n/useCopy";

/**
 * Short career timeline linking to the full resume.
 *
 * @component
 */

const ExperiencePreview = () => {
  const t = useCopy();
  return (
  <section className="homeSection container" aria-labelledby="experience-title">
    <SectionHeading eyebrow={t.sections.experience.eyebrow} title={t.sections.experience.title} id="experience-title" />
    <ol className="timeline">
      {resume.experience.slice(0, 5).map((job, i) => (
        <Reveal as="li" key={`${job.company}-${job.start}`} delay={i * 0.08}>
          <span className="timelinePeriod">{job.period}</span>
          <h3>
            {job.role} · <span className="hl">{job.company}</span>
          </h3>
          <p>{job.bullets[0]}</p>
          {job.project && (
            <Link className="timelineLink" to={`/portfolio/${job.project}`}>
              {t.sections.experience.caseLink}
            </Link>
          )}
        </Reveal>
      ))}
    </ol>
    <Reveal className="sectionCta">
      <Button name={t.sections.experience.button} to="/resume" />
    </Reveal>
  </section>
  );
};

export default ExperiencePreview;
